import { render } from "./GuestLayout.vue?vue&type=template&id=1ec1a3de"
import script from "./GuestLayout.vue?vue&type=script&lang=js"
export * from "./GuestLayout.vue?vue&type=script&lang=js"

import exportComponent from "D:\\SMS-Syariah\\server\\app\\sms pay corporate\\sms-pay-corporate\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__